module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_straight_vector.eb14bb87.svg";